<template>
  <div class="full-width">
    <AppEditForm
      padding
      class="row q-px-md q-mb-xl"
      @save="save"
      :edit="edit"
      :new="isNew"
    >
      <div class="gt-xl col-xl-2" />
      <div class="col-12 col-sm-9 col-xl-6 q-mt-md row">

        <div class="col-12 col-sm-6 q-px-sm">
          <AppInput v-if="!isNew"
                    label="Número do Tema do IRDR"
                    autogrow
                    type="textarea"
                    v-model="tema.numero"
          />
        </div>

        <div class="gt-xl col-xl-2" />
        <div class="gt-xl col-xl-2" />
        <div class="col-xl-12 col-sm-12" v-if="!isNew">
          <div class="col-12 q-px-sm">
            <q-chip outline color="primary" text-color="white">
              Número do processo do IRDR *
            </q-chip>
          </div>
          <AppInfiniteListForm v-model="processosparadigma">
            <template v-slot:item="data">
              <MiniProcessoParadigma v-bind="data" />
            </template>
            <ProcessoParadigma/>
          </AppInfiniteListForm>
          <div class="q-my-md">
          </div>
        </div>

        <div class="col-8 q-px-sm">
          <AppSelect
              label="Situação *"
              v-model="situacao"
              @filter="situacaoFilter"
              :options="situacoes"
              editable
          />
        </div>
        <div class="col-sm-4 col-12  q-px-sm">
          <AppDateSelect label="Data da Situação *" v-model="tema.dataSituacao" editable required/>
        </div>

        <div class="col-12 q-px-sm">
          <AppSelect
            label="Ramo do Direito"
            v-model="ramo"
            v-if="ramo || edit || userStore.admin"
            @filter="ramoFilter"
            :options="ramos"
            autofocus
            editable
          />
        </div>

        <div class="col-12 q-px-sm">
          <AppSelect
            label="Assuntos *"
            v-model="assunto"
            @filter="assuntoFilter"
            :options="assuntos"
            use-input
            multiple
            editable
          />
        </div>
        <div class="col-12 q-px-sm">
          <AppInput
            label="Questão submetida a julgamento *"
            autogrow
            type="textarea"
            v-model="tema.questao"
            v-if="tema.questao || edit || userStore.admin"
            editable
            required
            maxlength="4000"
            showCounter
          />
        </div>
        <div class="col-12 q-px-sm">
          <AppInput label="Tese jurídica fixada"
                    v-model="tema.tese"
                    v-if="tema.tese || edit || userStore.admin"
                    type="textarea"
                    autogrow
                    editable
                    maxlength="4000"
                    showCounter
          />
        </div>
        <div class="col-12 q-px-sm">
          <AppInput
            label="Referência Legislativa"
            autogrow
            v-if="tema.referenciaLegislativa || edit || userStore.admin"
            v-model="tema.referenciaLegislativa"
            editable
            maxlength="4000"
            showCounter
          />
        </div>

        <div class="col-12 q-px-sm" v-if="userStore.admin">
          <AppInput
              label="Texto Decisão Admissão"
              autogrow
              type="textarea"
              v-model="tema.textoDecisaoAdmissao"
              editable
              maxlength="4000"
              showCounter
          />
        </div>

        <div class="col-12 q-px-sm" v-if="userStore.admin">
          <AppInput
              label="Texto Ementa Admissão"
              autogrow
              type="textarea"
              v-model="tema.textoEmentaAdmissao"
              editable
              maxlength="4000"
              showCounter
          />
        </div>

        <div class="col-12 q-px-sm">
          <AppInput
              label="Relator"
              v-model="tema.relator"
              v-if="tema.relator"
              maxlength="255"
              showCounter
          />
        </div>

        <div class="col-12 q-px-sm" v-if="userStore.admin">
          <AppInput
              label="Texto Acórdão Admissão"
              autogrow
              type="textarea"
              v-model="tema.textoAcordaoAdmissao"
              editable
              maxlength="4000"
              showCounter
          />
        </div>

        <div class="col-12 q-px-sm" v-if="userStore.admin">
          <AppInput
              label="Texto Ementa Mérito"
              autogrow
              type="textarea"
              v-model="tema.textoEmentaMerito"
              editable
              maxlength="4000"
              showCounter
          />
        </div>

        <div class="col-12 q-px-sm" v-if="userStore.admin">
          <AppInput
              label="Texto Acórdão Mérito"
              autogrow
              type="textarea"
              v-model="tema.textoAcordaoMerito"
              editable
              maxlength="4000"
              showCounter
          />
        </div>

        <div class="col-12 q-px-sm" v-if="userStore.admin">
          <AppInput
              label="Texto Decisão Suspensão"
              autogrow
              type="textarea"
              v-model="tema.textoDecisaoSuspensao"
              editable
              maxlength="4000"
              showCounter
          />
        </div>

        <div class="col-sm-4 col-12  q-px-sm">
          <AppSelect
              label="Alcance do Sobrestamento *"
              v-model="parametro"
              v-if="parametro || edit || userStore.admin"
              @filter="parametroFilter"
              :options="parametros"
              editable/>
        </div>

        <div class="col-sm-6 col-12  q-px-sm">
          <AppDateSelect label="Data da Decisão do Alcance do Sobrestamento *" v-if="parametro" v-model="tema.dataSuspensao" editable required/>
        </div>

          <div class="col-12 q-px-sm">
            <AppInput
                label="Detalhe Abrangência Específica"
                v-if="parametro && (tema.detalheAbrangenciaEspecifica || edit || userStore.admin)"
                v-model="tema.detalheAbrangenciaEspecifica"
                editable
                autogrow
                maxlength="1000"
                showCounter
            />
          </div>

        <div class="col-12 q-px-sm">
          <AppInput
              label="Link Decisão"
              v-model="tema.linkDecisao"
              v-if="parametro && (tema.linkDecisao || edit || userStore.admin)"
              editable
              autogrow
              maxlength="1000"
              showCounter
          />
        </div>

        <div class="col-sm-7 col-12  q-px-sm q-mb-md">
          <AppDateSelect label="Data final da determinação de suspensão de processos" v-if="parametro" v-model="tema.dataFimSuspensao" editable/>
        </div>

        <div class="col-sm-12 col-12 q-px-sm q-mb-md" v-if="userStore.admin">
          <AppInput label="Número Tema Sobrestado"
                    v-model="tema.numeroTemaSobrestado"
                    editable
                    mask="####"
          />
        </div>

        <div class="col-12 q-px-sm">
          <AppInput
              label="Anotações NUGEPNAC"
              autogrow
              type="textarea"
              v-if="tema.anotacoesNugep || edit || userStore.admin"
              v-model="tema.anotacoesNugep"
              editable
          />
        </div>
        <div class="col-12 q-px-sm text-right">
          <q-chip v-if="tema.statusEnvioBnp && userStore.admin" outline square color="green" text-color="white" icon="done">
            Enviado ao BNP
          </q-chip>
          <q-chip v-if="!tema.statusEnvioBnp && userStore.admin" outline square color="red" text-color="white" icon="close">
            Não enviado ao BNP
          </q-chip>
          <q-chip v-if="tema.statusEnvioPje && userStore.admin" outline square color="green" text-color="white" icon="done">
            Enviado ao PJE
          </q-chip>
          <q-chip v-if="!tema.statusEnvioPje && userStore.admin" outline square color="red" text-color="white" icon="close">
            Não enviado ao PJE
          </q-chip>
        </div>
      </div>
      <AppTimeline
        class="col-12 col-sm-3 col-xl-2"
        v-model="timeline"
        :edit="edit || isNew"
        :requires=0
      />

      <div class="gt-xl col-xl-2" v-if="isNew"/>
      <div class="gt-xl col-xl-2" v-if="isNew"/>
      <div class="col-xl-8 col-sm-12" v-if="isNew">
        <div class="col-12 q-px-sm">
          <q-chip outline color="primary" text-color="white">
            Número do processo do IRDR *
          </q-chip>
        </div>
        <AppInfiniteListForm v-model="processosparadigma">
          <template v-slot:item="data">
            <MiniProcessoParadigma v-bind="data" />
          </template>
          <ProcessoParadigma/>
        </AppInfiniteListForm>
        <div class="q-my-md">
        </div>
      </div>

      <div class="gt-xl col-xl-2" />
      <div class="gt-xl col-xl-2" />
      <div class="col-xl-8 col-sm-12">
        <div class="col-12 q-px-sm">
          <q-chip outline color="primary" text-color="white" >
            Processo Incidente
          </q-chip>
        </div>
        <AppInfiniteListForm v-model="processosincidente">
          <template v-slot:item="data">
            <MiniProcessoIncidente v-bind="data" />
          </template>
          <ProcessoIncidente/>
        </AppInfiniteListForm>
      </div>
      <div class="gt-xl col-xl-2" />

      <q-page-sticky
        position="bottom-right"
        :offset="[18, 18]"
        v-if="userStore.admin"
      >
        <AppSaveBtn v-if="edit" :disable="disableButton"/>
        <AppDeleteBtn v-if="!isNew" @click="showConfirmDeletion" :disable="disableButton"/>
        <AppEditBtn v-if="!isNew" @click="toggleEditMode" />
      </q-page-sticky>
    </AppEditForm>
    <TjpaDemandasDeleteModal
      :show="showConfirmDeletionModal"
      @update:show="showConfirmDeletionModal = $event"
      @confirmDeletion="confirmDeletion"
      :id="$route.params.id"
    />
  </div>
</template>


<script setup>
import MiniProcessoParadigma from "@/components/app/AppMiniProcessoPje.vue";
MiniProcessoParadigma;
import AppInfiniteListForm from "@/components/app/AppInfiniteListForm.vue";
AppInfiniteListForm;
import ProcessoIncidente from "@/components/app/ProcessoIncidentePje.vue";
import MiniProcessoIncidente from "@/components/app/MiniProcessoIncidentePje.vue";
import ProcessoParadigma from "@/components/app/AppProcessoPje.vue";
import AppEditForm from "../app/AppEditForm.vue";
import AppDeleteBtn from "../app/AppDeleteBtn.vue";
import AppEditBtn from "../app/AppEditBtn.vue";
import AppSaveBtn from "../app/AppSaveBtn.vue";
import AppInput from "../app/AppInput.vue";
import AppSelect from "../app/AppSelect.vue";
import AppDateSelect from "../app/AppDateSelect.vue";
import AppTimeline from "@/components/app/AppTimeline.vue";
AppTimeline;
import TjpaDemandasDeleteModal from "../tjpa-demandas-delete-modal.vue";

import { useProcessoParadigmaStore } from "@/store/processoparadigma-store";

import { useTemaSituacaoStore } from "@/store/tema-situacao-store";
import { useParametroLimiteSuspensaoStore } from "@/store/parametro-store";
import { useTemaAssuntoStore } from "@/store/tema-assunto-store";
import { useTemaRamoStore } from "@/store/tema-ramo-store";

import { useTemaStore } from "@/store/tema-store";
import { useUserStore } from "@/store/user-store";

import {ref, computed, defineProps} from "vue";
import { useQuasar } from "quasar";
import { useRouter, useRoute } from "vue-router";

const quasar = useQuasar();
const router = useRouter();
const route = useRoute();

const userStore = useUserStore();
const ramoStore = useTemaRamoStore();
ramoStore.fetch();
const situacaoStore = useTemaSituacaoStore();
situacaoStore.fetch();
const parametroStore = useParametroLimiteSuspensaoStore();
parametroStore.fetch();
const assuntoStore = useTemaAssuntoStore();
assuntoStore.fetch();

const notify = (...p) => quasar.notify(...p);

const temaStore = useTemaStore();

import {
  filterFunction,
  baseUrlDelete,
  DELETE_FAILURE,
  DELETE_SUCCESS, CREATE_SUCCESS, ALTER_SUCCESS
} from "@/DemandasRepetitivas";
import {useProcessoIncidenteStore} from "@/store/processoincidente-store";

const procStore = useProcessoParadigmaStore();
const incStore = useProcessoIncidenteStore();

const props = defineProps({ id: { type: String } });
props.id && temaStore.fetchStg(props.id);

const _edit = ref(false);

const processosparadigma = computed({
  get: () => edit.value ? procStore.processos: tema.value.processosParadigma,
  set: v => (procStore.processos = v)
});

const processosincidente = computed({
  get: () => edit.value ? incStore.processos: tema.value.processosIncidente,
  set: v => (incStore.processos = v)
});

const tema = computed(() => temaStore.stgTema);

const sourceTema = computed(
  () => props.id && temaStore.all.find(t => t.id == props.id)
);

const isNew = computed(() => !props.id);
const showConfirmDeletionModal = ref(false);
const disableButton = ref(false);

const admin = computed(() => userStore.admin)
const situacoes = computed(() => situacaoStore.filtered);
const parametros = computed(() => parametroStore.filtered);
const assuntos = computed(() => assuntoStore.filtered);
const ramos = computed(() => ramoStore.filtered);

const ramo = computed({
  get: () => ramoStore.all?.find(e => e.codigo == tema.value.idRamoDireito),
  set: v => (tema.value.idRamoDireito = v.codigo)
});
const situacao = computed({
  get: () => (situacaoStore.all?.find(s => s.id == tema.value.idSituacaoTema)),
  set: v => (tema.value.idSituacaoTema = v ? v.id : null)
});
const parametro = computed({
  get: () => (parametroStore.all?.find(s => s.id == tema.value.parametro)),
  set: v => (tema.value.parametro = v ? v.id : null)
});
const assunto = computed({
  get: () => tema.value?.assuntoTema?.map(a => assuntoStore.assuntoAllList?.find(e => e.codigo == a.codigo)),
  set: v => tema.value.assuntoTema = v
});

const edit = computed({get:() => (_edit.value && admin.value),set:v=>(_edit.value = v)})

const toggleEditMode = () => {
  edit.value = !edit.value ;
  if(edit.value == true){
    procStore.processos = tema.value.processosParadigma;
    incStore.processos = tema.value.processosIncidente;
  }
  if (edit.value == false && tema.value.equals(sourceTema.value) == false) {
    notify({
      message: "Existem Alterações não salvas",
      color: "warning"
    });
  }
};

if (isNew.value) {
  temaStore.clearStg();
  procStore.clear();
  incStore.clear();
  edit.value = false;
  toggleEditMode();
}

const timeline = computed({
  get: () => {
    const { dataAdmissao, dataJulgamento, dataPublicacao, dataTransitoJulgado } = tema.value;
    return [
      { order: 1, name: "Admissão *", date: dataAdmissao, icon: "launch" },
      { order: 2, name: "Julgamento de Mérito", date: dataJulgamento, icon: "gavel" },
      { order: 3, name: "Publicação do Acórdão", date: dataPublicacao, icon: "publish" },
      { order: 4, name: "Transitado em Julgado", date: dataTransitoJulgado, icon: "done_all" }
    ];
  },
  set: v => {
    let timelineFields = ["Admissao", "Julgamento", "Publicacao", "TransitoJulgado"];
    timelineFields = timelineFields.map(
      fieldName => (fieldName = `data${fieldName}`)
    );
    timelineFields.forEach(
      (fieldName, i) => (tema.value[fieldName] = v[i].date)
    );
  }
});

const ramoFilter = (val, update) =>
  filterFunction(...[ramos.value, ramoStore.all, val, update]);
const situacaoFilter = (val, update) =>
  filterFunction(...[situacoes.value, situacaoStore.all, val, update]);
const parametroFilter = (val, update) =>
    filterFunction(...[parametros.value, parametroStore.all, val, update]);
const assuntoFilter = (v, up) =>
  filterFunction(...[assuntos.value, assuntoStore.assuntoAllList, v, up]);

const save = async () => {

  if (!situacao.value) {
    notify({
      message: "É obrigatória a escolha de uma situação.",
      color: "warning"
    });
    return;
  }

  if (!parametro.value) {
    notify({
      message: "É obrigatória a escolha do Alcance do Sobrestamento.",
      color: "warning"
    });
    return;
  }

  if (assunto.value.length == 0) {
    notify({
      message: "É obrigatória a escolha de pelo menos um assunto.",
      color: "warning"
    });
    return;
  }

  if (procStore.processos.length > 1) {
    notify({
      message: "Não é possível o vínculo de mais de 1 processo.",
      color: "warning"
    });
    return;
  }

  if (procStore.processos.length == 0) {
    notify({
      message: "É obrigatório o vinculo de 1 processo ao IRDR.",
      color: "warning"
    });
    return;
  }

  disableButton.value = true;

  let success_msg = isNew.value ? CREATE_SUCCESS : ALTER_SUCCESS;
  const reload = () => temaStore.clearStg();
  const failure = msg =>
    notify({
      message: msg,
      color: "negative"
    });
  const success = (id) =>
    notify({
      message: `O Tema ${id} ` + success_msg,
      color: "positive"
    });

  const successAndReload = id => {
    success(id);
    router.push("/");
    if(isNew.value){
      reload();
    }
  };
  try {
    const readResponse = await temaStore.saveStg();
    successAndReload(readResponse.data);
    //failure(id);
  } catch (e) {
    disableButton.value = false;
    if(e.response.status == 401){
      failure("Sessão Expirou.");
      router.push("/");
      reload();
    }else{
      failure(e.response.data.message);
    }
  }
};

const goHome = () => router.push("/");

const showConfirmDeletion = () => (showConfirmDeletionModal.value = true);

const confirmDeletion = () => {
  disableButton.value = true;
  const reload = () => goHome();

  const notifyObj = (message, color) => ({ message, color });
  const failure = () => notify(notifyObj(DELETE_FAILURE, "negative"));
  const success = () => notify(notifyObj(DELETE_SUCCESS, "positive"));

  const successAndReload = () => {
    success();
    reload();
  };
  const httpOk = r => r.status == 200;
  const readResponse = r => (httpOk(r) ? successAndReload() : failure());

  baseUrlDelete(`tema/${route.params.id}`)
    .then(readResponse)
    .catch(failure);
};
</script>

<style lang="scss" >
@import "@/styles/quasar.variables.sass";

.tjpa-select-input {
  max-height: 30vh !important;
}

.AppSelect__dialog {
  margin-top: 90px;
}
</style>
